export const positivenumbers = (evt) => {
	if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
	{
		evt.preventDefault()
	}
}


// WEBPACK FOOTER //
// ./src/utils/helperfunctions/positivenumbers.js